module.exports = __webpack_public_path__ + "img/20210730_121336.e017e84d.jpg";